const camelize = (str, includeFirst = false) => {
  let result = str.replace(/_([a-z])/g, (_, letter) => letter.toUpperCase());
  if (includeFirst) result = result.charAt(0).toUpperCase() + result.slice(1);
  return result;
};

export default camelize;
